module.exports = __webpack_public_path__ + "static/img/3.b25f512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpitCh/3.png
// module id = ZMo0
// module chunks = 31